import * as MutationTypes from './mutation-types'
import estados from '@/store/helpers/unidades-federacao'
import PacienteService from '@/services/paciente-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { format } from 'date-fns'

export default {
  state: {
    ufs: [],
    proximosAgendamentos: null,
    documentosRecentes: null,
    dados: null,
    atestados: [],
    dadosOriginais: null,
    outrosServicos: [],
    racaCor: [],
    etnias: [],
    aceiteTelerradiologia: false
  },

  getters: {
    getAtestados(state) {
      return state.atestados
    },
    getUFS: (state) => state.ufs,
    dadosPaciente: (state) => state.dados,
    dadosOriginais: (state) => state.dadosOriginais,
    proximosAgendamentos: (state) => state.proximosAgendamentos,
    documentosRecentes: (state) => state.documentosRecentes,
    agendamentosDeHoje: (state) => {
      if (state.proximosAgendamentos == null) return []

      let agendamentosOrdenados = state.proximosAgendamentos
        .filter((m) => m.DataVaga === format(new Date(), 'dd/MM/yyyy'))
        .sort((a, b) => {
          let horaA =
            a.DataRecepcao !== null
              ? format(new Date(a.DataRecepcao), 'HH:mm')
              : a.Hora
          let horaB =
            b.DataRecepcao !== null
              ? format(new Date(b.DataRecepcao), 'HH:mm')
              : b.Hora
          return horaA.localeCompare(horaB)
        })
      return agendamentosOrdenados
    },
    proximoAgendamentoHoje: (state, getters) => {
      return getters.agendamentosDeHoje.find(
        (m) => m.SituacaoAtendimento !== 'A'
      )
    },
    getOutrosServicos: (state) => state.outrosServicos,
    getRacaCor: (state) => state.racaCor,
    getEtnias: (state) => state.etnias,
    getAceiteTelerradiologia: (state) => state.aceiteTelerradiologia
  },

  mutations: {
    [MutationTypes.SET_UFS](state, ufs) {
      state.ufs = ufs
    },
    [MutationTypes.SET_DADOS_PACIENTE](state, value) {
      state.dados = value
    },
    [MutationTypes.UPDATE_DADOS_PACIENTE_ORIGINAIS](state, value) {
      state.dadosOriginais = Object.assign({}, value)
    },
    [MutationTypes.GET_ATESTADOS](state, payload) {
      state.atestados = payload
    },
    [MutationTypes.SET_AVATAR](state, value) {
      state.dados.Avatar = value
    },
    [MutationTypes.SET_PROXIMOS_AGENDAMENTOS](state, value) {
      state.proximosAgendamentos = value
    },
    [MutationTypes.SET_DOCUMENTOS_RECENTES](state, value) {
      state.documentosRecentes = value
    },
    [MutationTypes.GET_OUTROS_SERVICOS](state, value) {
      state.outrosServicos = value
    },
    [MutationTypes.SET_RACA_COR](state, value) {
      state.racaCor = value
    },
    [MutationTypes.SET_ETNIAS](state, value) {
      state.etnias = value
    },
    [MutationTypes.SET_ACEITE_TELERRADIOLOGIA](state, value) {
      state.aceiteTelerradiologia = value
    }
  },

  actions: {
    setUFS({ commit }) {
      commit(MutationTypes.SET_UFS, estados)
    },
    async getPaciente({ commit }, idPaciente) {
      commit('setLoadingState', true)
      await PacienteService.getPaciente(idPaciente)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_DADOS_PACIENTE, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          throw err
        })
    },
    async atualizarPaciente({ state, commit }) {
      commit('setLoadingState', true)
      await PacienteService.atualizarPaciente(state.dados)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
        })
        .then(() => {
          commit(MutationTypes.UPDATE_DADOS_PACIENTE_ORIGINAIS, state.dados)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          throw err
        })
    },
    async atualizarAvatar({ commit }, codigo) {
      commit('setLoadingState', true)
      await PacienteService.atualizarAvatar(codigo)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
        })
        .then((data) => {
          commit('setLoadingState', false)
        })
        .catch((err) => {
          throw err
        })
    },
    async getProximosAgendamentos({ commit }, quantidade) {
      await PacienteService.proximosAgendamentos(quantidade)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_PROXIMOS_AGENDAMENTOS, data)
        })
        .catch((err) => {
          throw err
        })
    },
    async getDocumentosRecentes({ commit }, quantidade) {
      await PacienteService.documentosRecentes(quantidade)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_DOCUMENTOS_RECENTES, data)
        })
        .catch((err) => {
          throw err
        })
    },
    async obterOutrosServicos({ commit }, payload) {
      commit('setLoadingState', true)
      await PacienteService.getSolicitacoesDocumentos({ ...payload })
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          if (res.status === 204) return []
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.GET_OUTROS_SERVICOS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async setAtestados({ commit }, payload) {
      commit('setLoadingState', true)
      await PacienteService.getSolicitacoesDocumentos({ ...payload })
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          if (res.status === 204) return []
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.GET_ATESTADOS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async getEtnias({ commit }) {
      await PacienteService.getEtnias()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_ETNIAS, data)
        })
        .catch((err) => {
          throw err
        })
    },
    async getRacaCor({ commit }) {
      await PacienteService.getRacaCor()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_RACA_COR, data)
        })
        .catch((err) => {
          throw err
        })
    },
    async getAceite({ commit }) {
      await PacienteService.getExisteAceiteTelerradiologia()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_ACEITE_TELERRADIOLOGIA, data)
        })
        .catch((err) => {
          throw err
        })
    },
    async incluirAceiteTelerradiologia({ commit }) {
      await PacienteService.incluirAceiteTelerradiologia().then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) throw new NotAuthenticatedError()
          let erros = await res.json()
          throw erros
        }
        commit(MutationTypes.SET_ACEITE_TELERRADIOLOGIA, true)
      })
    },
    async atualizarDadosPessoais({ commit }, dados) {
      await PacienteService.atualizarDadosPessoais(dados).then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) throw new NotAuthenticatedError()
          let erros = await res.json()
          throw erros
        }
      })
    },
    async atualizarContato({ commit }, dados) {
      await PacienteService.atualizarContato(dados).then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) throw new NotAuthenticatedError()
          let erros = await res.json()
          throw erros
        }
      })
    },
    async atualizarEndereco({ commit }, dados) {
      await PacienteService.atualizarEndereco(dados).then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) throw new NotAuthenticatedError()
          let erros = await res.json()
          throw erros
        }
      })
    }
  }
}
